import { render, staticRenderFns } from "./PanelNavigation.vue?vue&type=template&id=897ffc58&scoped=true"
import script from "./PanelNavigation.vue?vue&type=script&lang=js"
export * from "./PanelNavigation.vue?vue&type=script&lang=js"
import style0 from "./PanelNavigation.vue?vue&type=style&index=0&id=897ffc58&prod&lang=css&scoped=true"
import style1 from "./PanelNavigation.vue?vue&type=style&index=1&id=897ffc58&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "897ffc58",
  null
  
)

export default component.exports